module.exports = __webpack_public_path__ + "img/主题同步.63ab4761.svg";